import { listingCorpsDeMeubleMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listingCorpsDeMeubleMock];

export const corpsDeMeubleMock: SlugPage = {
  ...pageBase({
    title: 'Corps de meuble',
    type: 'corps-de-meuble',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
